import { FieldType } from '@databases/model/field';
import { type MutableValue } from '@databases/model/value';
import { type DatabaseChangeType } from '@databases/types/redux';

import { MultiValueChangeType } from '../../../../database/changesets.ts';
import { type YJSChangeHandler } from '../../types.ts';

export const setSelectOptions: YJSChangeHandler<
  DatabaseChangeType.SET_SELECT_OPTIONS
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];
    if (field) {
      switch (change.change.type) {
        case MultiValueChangeType.APPEND:
          field.selectOptions.add({
            id: change.change.value.id ?? change.change.value.label,
            label: change.change.value.label,
            color: change.change.value.color
          });

          break;

        case MultiValueChangeType.REMOVE: {
          const option = field.selectOptions.options[change.change.index].id;

          field.selectOptions.delete(change.change.index);

          db.entries.forEach((entryId) => {
            const value = db.entriesById[entryId].getValue(change.fieldId);

            if (value && value.type === FieldType.Select) {
              (value as MutableValue<FieldType.Select>).delete([option]);
            }
          });

          break;
        }

        case MultiValueChangeType.REORDER:
          field.selectOptions.reorder(change.change.currentIndex, change.change.newIndex);

          break;

        case 'set_color':
          if (field.selectOptions.options[change.change.index]) {
            field.selectOptions.options[change.change.index].color = change.change.color;
          }

          break;

        case 'update_label':
          field.selectOptions.options[change.change.index]?.applyLabelDelta(
            change.change.delta
          );

          break;
      }
    }
  });
};
